import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import { campaignAdProductLabel, type CampaignAdProduct } from '@/types/spCampaigns';

const OPTIONS: { type: CampaignAdProduct; description: string }[] = [
  {
    type: 'SP',
    description: 'Product ads in search results and on product pages.',
  },
  {
    type: 'SB',
    description: 'Brand-focused ads with custom headlines and landing pages.',
  },
  {
    type: 'SD',
    description: 'Display ads on and off Amazon with audience or context targeting.',
  },
];

function createCampaignPath(profileId: string, type: CampaignAdProduct): string {
  return `/accounts/${encodeURIComponent(profileId)}/campaigns/new/${type.toLowerCase()}`;
}

export function CampaignTypePickerModal({
  profileId,
  isOpen,
  onClose,
}: {
  profileId: string;
  isOpen: boolean;
  onClose: () => void;
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-surface rounded-xl max-w-lg w-full p-6 shadow-xl">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">New campaign</h3>
          <button type="button" onClick={onClose} className="text-chrome-label hover:text-foreground-muted">
            <X className="w-5 h-5" />
          </button>
        </div>
        <p className="text-sm text-foreground-muted mb-4">Choose the ad product for your new campaign.</p>
        <div className="space-y-3">
          {OPTIONS.map(({ type, description }) => (
            <Link
              key={type}
              to={createCampaignPath(profileId, type)}
              onClick={onClose}
              className="block w-full text-left border border-border rounded-xl px-4 py-3 hover:border-brand hover:bg-brand/5 transition-colors"
            >
              <div className="font-medium text-foreground">{campaignAdProductLabel(type)}</div>
              <div className="text-sm text-foreground-muted mt-0.5">{description}</div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
